import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { filter, take } from 'rxjs';

import {
  NotificationBarRef,
  NotificationBarService,
} from '@lockton-apps/shared/ui/lui';
import { Quote, QUOTE_STATUSES } from '@lockton-apps/shared/interfaces';
import { getProposalUrl } from '@lockton-apps/shared/util/proposal-utils';

@Injectable({
  providedIn: 'root',
})
export class RenewalNotificationsService {
  constructor(
    private router: Router,
    private notificationBarService: NotificationBarService
  ) {}

  openForContact(quote: Quote) {
    let bar: NotificationBarRef | null = null;
    let path: Array<any> = ['/'];

    if (quote.status === QUOTE_STATUSES.FormIncomplete) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Your Master Policy is due for renewal.</span> Please complete your Master Policy Renewal Proposal to continue another year of cover.`,
        primaryButtonText: $localize`View proposal form`,
        closeOnNavigation: true,
      });
      path = getProposalUrl(quote);
    }
    if (
      quote.status === QUOTE_STATUSES.FormComplete ||
      quote.status === QUOTE_STATUSES.Quoted
    ) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Your Master Policy is being processed.</span> You will recieve an email when your quote is ready to view.`,
        primaryButtonText: $localize`View proposal form`,
        closeOnNavigation: true,
      });
      path = getProposalUrl(quote);
    }
    if (quote.status === QUOTE_STATUSES.BrokerApproved) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Your Master Policy Renewal quote is ready.</span> You can view your quote and completed proposal here.`,
        primaryButtonText: $localize`View quote`,
        closeOnNavigation: true,
      });
      path = ['/quotes', quote.id];
    }

    bar &&
      bar
        .onClose()
        .pipe(take(1), filter(Boolean))
        .subscribe(() => {
          this.router.navigate(path);
          bar = null;
        });
  }
  openForBroker(quote: Quote) {
    let bar: NotificationBarRef | null = null;
    let path: Array<any> = ['/'];

    if (quote.status === QUOTE_STATUSES.FormIncomplete) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Master Policy Renewal Proposal is in progress.</span> View full renewal status here.`,
        primaryButtonText: $localize`Renewal Status`,
        closeOnNavigation: true,
      });
      path = ['/lsos', quote.clientId, 'renewals'];
    }
    if (quote.status === QUOTE_STATUSES.FormComplete) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Master Policy has been submitted by the client.</span>`,
        primaryButtonText: $localize`View Renewal`,
        closeOnNavigation: true,
      });
      path = ['/lsos', quote.clientId, 'renewals'];
    }
    if (quote.status === QUOTE_STATUSES.Quoted) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Master Policy Renewal Quote is ready</span>`,
        primaryButtonText: $localize`View quote`,
        closeOnNavigation: true,
      });
      path = ['/quotes', quote.id];
    }
    if (quote.status === QUOTE_STATUSES.BrokerApproved) {
      bar = this.notificationBarService.open({
        icon: 'expire_pending',
        iconColor: 'orange',
        message: $localize`<span class="fw-b">Master Policy Renewal Quote has been sent to the client.</span> View full renewal status here.`,
        primaryButtonText: $localize`Renewal Status`,
        closeOnNavigation: true,
      });
      path = ['/lsos', quote.clientId, 'renewals'];
    }

    bar &&
      bar
        .onClose()
        .pipe(take(1), filter(Boolean))
        .subscribe(() => {
          this.router.navigate(path);
          bar = null;
        });
  }
}
